/**
 * 自定义指令 用于判断是否开启钉钉审批
 * 接口文档： http://10.136.3.69:8080/doc.html#/%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3/%E5%AE%A1%E6%89%B9%E6%A8%A1%E6%9D%BF%E9%85%8D%E7%BD%AE%20resourceKey=approval_template_config/getState
 * @params: {
 *    "id": 0, 主键
 *     "bizType": ""  业务类型
 * 1收款审批
 * 2租赁退车付款审批
 * 3租赁退车收款审批
 * 4支付宝支付解约
 * 5网约钱包支付解约
 * 可用值:1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25
 *  }
 */
import { getSubmitDingTalkShow } from '@/api/global'

export const submitDingTalkShow = {
  async bind(el, binding, vnode) {
    // 判断参数是否数组 还是 string
    let bizType = ''
    const innerHTML = '提交审批'

    bizType = Array.isArray(binding.value) ? binding.value[0] : binding.value

    // innerHTML =  binding.value[1]
    const res = await getSubmitDingTalkShow({
      bizType,
    })
    if (res.code === 1 && res.data) {
      // 20 30
      vnode.context.$parent[`DingTalkShow${bizType}`] = res.data
      vnode.context[`DingTalkShow${bizType}`] = res.data
      const child = getFirstNonCommentChild(el)
      child.innerHTML = innerHTML
    }
    return res.data
  },
}

function getFirstNonCommentChild(el) {
  let child = el.firstChild
  // 循环直到找到非注释节点
  while (child && child.nodeType === 8) { // Node.COMMENT_NODE 是8
    child = child.nextSibling
  }
  return child
}

export default submitDingTalkShow
